<div class="page-wrapper">
    <div class="authentication-box">
        <div class="container">
            <div class="row">
                <div class="col-md-5 p-0 card-left">
                    <div class="card bg-primary">
                        <div class="svg-icon d-flex align-items-center justify-content-center">
                            <img src="assets/images/dashboard/ecommerce-logo.png" alt="Site Logo"
                                class="img-100 rounded-circle">
                        </div>
                        <div class="single-item">
                            <owl-carousel-o [options]="owlcarouselOptions">
                                <ng-container *ngFor="let data of owlcarousel">
                                    <ng-template carouselSlide class="item">
                                        <div>
                                            <h3>{{data.title}}</h3>
                                            <p>{{data.desc}}</p>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </owl-carousel-o>
                        </div>
                    </div>
                </div>
                <div class="col-md-7 p-0 card-right">
                    <div class="card tab2-card">
                        <div class="card-body">
                            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                                <li [ngbNavItem]="1">
                                    <a ngbNavLink><i class="icon-user mr-2"></i> Vendor Forgot Password</a>
                                    <ng-template ngbNavContent>
                                        <div class="tab-pane fade active show" id="account" role="tabpanel"
                                            aria-labelledby="account-tab">
                                            <form [formGroup]="forgotSubmitForm" (ngSubmit)="onForgotSubmit()">
                                                <div class="form-group">
                                                    <label for="validationCustom01"
                                                        class="col-form-label pt-0"><span>*</span> Register Email
                                                    </label>
                                                    <input class="form-control" id="validationCustom01" type="text"
                                                         formControlName="register_email">
                                                </div>
                                                <div class="form-button">
                                                    <button class="btn btn-primary" [disabled]="btndesable"
                                                        type="submit">Verify</button>
                                                </div>
                                            </form>
                                        </div>
                                    </ng-template>
                                </li>
                            </ul>
                            <div [ngbNavOutlet]="nav" class="mt-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>